import { siteConfig } from "../../config/site";
import { useInView } from "../../hooks/useInView";

export function CtaBanner() {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 pb-16 sm:pb-20">
      <div
        ref={ref}
        className={`flex flex-col items-start justify-between gap-6 rounded-[28px] bg-[#0a6c6d] p-8 sm:flex-row sm:items-center sm:p-10 ${inView ? "in-view" : ""}`}
      >
        <div className="flex flex-col items-start gap-1">
          <span className="reveal-scroll delay-1 text-xs font-semibold uppercase tracking-[0.6px] text-white/70">
            Ready to get started?
          </span>
          <h2 className="reveal-scroll delay-2 text-2xl font-bold leading-tight text-white sm:text-3xl">
            Take the next step
            <br />
            towards your goals.
          </h2>
        </div>

        <p className="reveal-scroll delay-3 max-w-[320px] text-sm leading-6 text-white/85">
          Fast, Easy, and Paperless
          <br />
          Personal Loans with instant approval and bank-grade security.
        </p>

        <a
          href={siteConfig.applyLink || undefined}
          target="_blank"
          rel="noopener noreferrer"
          className="reveal-scroll delay-4 flex shrink-0 items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-semibold text-[#0a6c6d] shadow-[0px_2px_8px_rgba(0,0,0,0.1)] transition-opacity hover:opacity-90"
        >
          Apply Now
          <span aria-hidden="true">→</span>
        </a>
      </div>
    </section>
  );
}
